import Icon from '@ant-design/icons/lib/components/Icon';
import * as React from 'react';
const IDelete = (props: any) => {
  return (
    <Icon
      component={() => {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="20"
            viewBox="0 0 16 20"
            fill={props.color ?? '#37474F'}
          >
            <path
              d="M6 0L5 1H1H0V3H1V18C1 19.0931 1.90694 20 3 20H13C14.0931 20 15 19.0931 15 18V3H16V1H15H14H11L10 0H6ZM3 3H13V18H3V3Z"
              fill={props.color ?? '#37474F'}
            />
          </svg>
        );
      }}
      {...props}
    />
  );
};

export default IDelete;
